import { Colors, Lightning } from '@lightningjs/sdk'
// import List from "../../lib/ui/List";
import GridPageCover from '../coverItems/GridPageCover'
import Slider from './Slider'
import ImageItemWrapper from '../../lib/ui/helpers/ImageItemWrapper'

export default class Strip extends Lightning.Component {
  static _template() {
    return {
      Title: {
        x: 0,
        y: 0,
        w: 800,
        h: 45,
        color: Colors('white').get(),
        text: {
          text: '',
          textAlign: 'left',
          fontSize: 35,
          maxLines: 1,
          fontFace: 'OpenSansRegular',
          maxLinesSuffix: '...',
          lineHeight: 38,
        },
      },
      List: {
        type: Slider,
        h: 575,
        w: 1600,
        y: 69,
        orientation: 'horizontal',
        spacing: 45,
        signals: { filled: true, listIndex: true, requestMoreItems: true },
      },
    }
  }

  set items(obj) {
    this._item = obj
  }
  set sliderIndex(v) {
    this._listIndex = v
    this.tag('List').index = v
  }
  get sliderIndex() {
    return this.tag('List').index
  }

  get currentItem() {
    return this.tag('List').currentItem.item
  }
  get listCurrentItem() {
    return this.tag('List').currentItem
  }
  _active() {
    if (this._listIndex) {
      this.tag('List').index = this._listIndex
      this._listIndex = 0
    }
  }

  static get width() {
    return this.w
  }

  static get height() {
    return 480
  }

  static get idx() {
    return this.index
  }

  _update() {
    if (!this.active || this._item === undefined) {
      return
    }

    this.patch({
      Title: { text: { text: this._item.title } },
      List: { listRef: this._item.title },
    })

    this.tag('List').items = this._item.data.map((item, idx) => {
      item.colIdx = idx

      return {
        ref: `StripCol-${idx}`,
        w: 420,
        h: 540,
        type: ImageItemWrapper,
        itemType: GridPageCover,
        item,
      }
    })
  }

  _firstActive() {
    this._update()
  }

  _init() {
    this._setState('Idle')
  }

  listIndex(obj) {
    this.signal('changeListIndex', obj)
  }

  static _states() {
    return [
      class Idle extends this {
        filled() {
          this._setState('StripFilled')
        }

        _getFocused() {
          return this
        }
      },

      class StripFilled extends this {
        $enter() {
          this.signal('filled')
        }

        _getFocused() {
          if (this.tag('List').currentItem.isComponent) {
            return this.tag('List')
          }

          return this
        }
      },
    ]
  }
}
